import template from './asicAppointmentPreview.html';
import AsicAppointmentPreviewCtrl from './asicAppointmentPreviewCtrl';

export default {
  template,
  controller: AsicAppointmentPreviewCtrl,
  controllerAs: 'vm',
};
